import React, {useContext, useState } from "react";
import Navbar from "react-bootstrap/Navbar";
import Nav from "react-bootstrap/Nav";
import Container from "react-bootstrap/Container";
import logo from "../Assets/logo.png";
import chair from "../Assets/chair.png";
import chairHover from "../Assets/chair-hover.png";
import "../design.css";
import { Link, useLocation } from "react-router-dom";
import { BiArrowBack } from "react-icons/bi";
import { AppContext } from "../App";

function NavBar() {
  const [expand, updateExpanded] = useState(false);
  const [navColour, updateNavbar] = useState(false);
  const location = useLocation();
  const { showGallery, setShowGallery } = useContext(AppContext);
  const isDesignPage = location.pathname === '/design';
  const [rtoImage, setRtoImage] = useState(true);
  
  function returnNavBarToggle(){
    if (!isDesignPage) {
      return (
        <Navbar.Toggle
          aria-controls="responsive-navbar-nav"
          onClick={() => {
            updateExpanded(expand ? false : "expanded");
          }}
        >
          <span></span>
          <span></span>
          <span></span>
        </Navbar.Toggle>
      )
    }
    return
  }

  function returnNavBarLinks() {
    if (isDesignPage & !showGallery){
      return (
        <Nav.Item
          onMouseOver={() => setRtoImage(false)}
          onMouseOut={() => setRtoImage(true)}
        >
          <Nav.Link as={Link} to="/">
          <p id={rtoImage ? "design-nav" : "design-nav-hover"}>
          RTO&nbsp;
          <img src={rtoImage ? chair : chairHover} className="rto-chair" />
          </p>
          </Nav.Link>
        </Nav.Item>
      )
    } else if (showGallery) {
      return (
        <Nav.Item>
          <button style={{background:"none", border: "none"
          }}
          onClick={() => setShowGallery(false)}>
          <BiArrowBack/>
          </button>
        </Nav.Item>
      )
    } else {
      return (<Navbar.Collapse id="responsive-navbar-nav">
      <Nav className="ms-auto" defaultActiveKey="#home">
        <Nav.Item>
          <Nav.Link as={Link} to="/" onClick={() => updateExpanded(false)}>
            work
          </Nav.Link>
        </Nav.Item>

        <Nav.Item>
          <Nav.Link
            as={Link}
            to="/about"
            onClick={() => updateExpanded(false)}
          >
            about
          </Nav.Link>
        </Nav.Item>
      </Nav>
    </Navbar.Collapse>)
    }
  }
  
  function scrollHandler() {
    if (window.scrollY >= 20) {
      updateNavbar(true);
    } else {
      updateNavbar(false);
    }
  }

  window.addEventListener("scroll", scrollHandler);

  return (
    <Navbar
      expanded={expand}
      fixed="top"
      expand="md"
      className={navColour ? "navbar" : "navbar"}
    >
      <Container>
        <Navbar.Brand href="/" className="d-flex">
          <img src={logo} className="img-fluid logo" alt="brand" />
        </Navbar.Brand>
        {returnNavBarToggle()}
        {returnNavBarLinks()}
      </Container>
    </Navbar>
  );
}

export default NavBar;
